import { loadCheckoutDraft } from './checkoutDraftSession';
import { loadPendingCheckout } from './checkoutPendingSession';

export type CheckoutBootstrap = {
  step: 1 | 2;
  paymentMethod: 'credit_card' | 'pix' | 'boleto' | null;
  isRestoring: boolean;
};

export function getCheckoutBootstrap(planId: string, period: string): CheckoutBootstrap {
  if (typeof window === 'undefined') {
    return { step: 1, paymentMethod: null, isRestoring: false };
  }

  const urlToken = new URLSearchParams(window.location.search).get('token');
  const stored = loadPendingCheckout();
  const draft = loadCheckoutDraft();
  const storedPlanOk = !stored || (stored.planId === planId && stored.period === period);
  const draftPlanOk = Boolean(draft && draft.planId === planId && draft.period === period);

  const hasPendingToken = Boolean((urlToken || stored?.continuationToken) && storedPlanOk);
  const resumeStep2 = Boolean((draftPlanOk && draft?.step === 2) || hasPendingToken);

  const paymentMethod =
    stored && storedPlanOk ? stored.chargedPaymentMethod : null;

  return {
    step: resumeStep2 ? 2 : 1,
    paymentMethod,
    isRestoring: hasPendingToken || (draftPlanOk && draft?.step === 2),
  };
}
